<script setup lang="ts">
import AltraIcon from "@/components/AltraIcon.vue";
const props = withDefaults(defineProps<{
  title: string,
  description: string,
}>(), {
  title: "",
  description: "",
  color: "var(--c-sky-blue)",
  tags: () => [],
  icon: ""
})
</script>

<template>
  <Frame class="sec-block relative" w="grid grid-cols-[auto_1fr] g-0.66">
    <slot name="top" />
    <Frame class="sec-icon w-full h-full flex items-start justify-center">
      <div class="icon w-40px h-40px flex items-center justify-center">
        <div class="outer w-80% flex items-center justify-center">
          <slot name="icon">
          <AltraIcon class="w-40px h-auto" />
          </slot>
        </div>
      </div>
    </Frame>
    <Frame class="sec-content" w="grid g-1">
      <div class="sec-title">
        <div class="label gmb-0.5 fs-1.5! glh-1.25! text-[var(--a-dark-blue)]!">{{ title }}</div>
        <div class="line"></div>
      </div>
      <div class="sec-description text-[var(--base-600)]!">
        {{description}}
      </div>
    </Frame>
    <slot name="bottom" />
  </Frame>
</template>

<style lang="scss" scoped>
.sec-block {

  display: grid;
  gap: gr(0);
  background: white;
  padding: gr(1.5) gr(1) gr(1.5) gr(1);
  // border-radius: gr(1);

  // @apply shadow-lg;
  border: 1px solid #b4c2c6;

  .sec-icon {
    .icon {
      border-radius: 100%;

      // border: 1px solid var(--base-500);
      

    }
  }

  .sec-content {
    .sec-title {
     
      font-size: fs(1);
      display: grid;
      gap: gr(0.4);


      >.label {
        font-size: fs(1);
        
      }

      >.line {
        width: 50px;
        height: 1px;
        background-color: var(--c-sky-blue);

        transition: all 0.3s ease;
      }
    }


    .sec-description {
      font-size: fs(-0.5);
      color: #7c889d;
    }
    
  }

  &:hover {
    .sec-content {
      .sec-title {
        .line {
          width: 120px;
        }
      }
    }
  }
}


</style>